import { log } from "../../Helper";
import { validationStatus } from "../utility/constants";

export function validateSelection(selectedOrders) {
    let noProviderCount = 0;
    let withProviderCount = 0;
    log("Selected machine for provider validations :: ", selectedOrders);
    for (let index = 0; index < selectedOrders.length; index++) {
      if (selectedOrders[index].providerList === "No provider found") {
        noProviderCount++;
      } else {
        withProviderCount++;
      }
    }
    
    if (noProviderCount === selectedOrders.length) {
      return validationStatus.TRUE;
    } else if (noProviderCount > 0 && withProviderCount > 0) {
      return validationStatus.ERROR;
    }
    return validationStatus.FALSE;
  } 

  export function validateProvider(selectedOrders) {
    let validationResult = true;
    log("Selected machine for provider validations :: ", selectedOrders);
    for (let index = 0; index < selectedOrders.length; index++) {
      let provider = selectedOrders[0].providerList;
      if (selectedOrders[index].providerList != provider) {
        validationResult = false;
      } 
    }
    return validationResult;
  } 
